import React from 'react';
import PropTypes from 'prop-types';
import { athletePropTypes } from '../../hooks/UseAppContext';
import constants from '../../constants';
import classNames from 'classnames/bind';

import styles from './AthletesSummary.module.scss';

function AthletesSummary({ athletes, evaluation, tab, handleTabChange }) {
  const cx = classNames.bind(styles);

  const list =
    tab === 0
      ? [...athletes]
      : [...athletes]
          .filter((item) => evaluation[item.id])
          .map((item) => ({
            ...item,
            eval: evaluation[item.id],
          }));

  const handleTabClick = (value) => () => {
    handleTabChange(value);
  };

  return (
    <section className={styles.wrapper}>
      <h3 className={styles.title}>{constants.athletes.summary}</h3>
      <nav className={styles.nav}>
        <ul className={styles.tabs}>
          {constants.tabs.map((label, index) => (
            <li
              className={cx({
                tab: true,
                tabSelected: tab === index,
              })}
              role="button"
              key={`AthletesSummary__key__tab__${index}__${Math.random()}`}
              onClick={handleTabClick(index)}
            >
              {label}
            </li>
          ))}
        </ul>
      </nav>
      <ol className={styles.list}>
        {constants.evalOrder.map((value) => {
          const current = constants.eval[value];
          const total = list.filter((item) => item.eval === value).length;
          const points = total * value;
          return (
            <li
              className={cx(['row', `rowLevel${value}`])}
              key={`AthletesSummary__key__row__${value}__${Math.random()}`}
            >
              <div className={cx(['rowHead', `level${value}`])}>
                <div className={styles.rowEmoji}>{current.emoji}</div>
                <b className={styles.rowTitle}>{current.title}</b>
                <div className={styles.rowTitle}>
                  {`${total} ${constants.getPlural.athlete(
                    total
                  )} = ${points} ${constants.getPlural.point(points)}`}
                </div>
              </div>
              <ul className={styles.athletes}>
                {/*<button
                  type="button"
                  className={styles.button}
                  title={constants.athletes.buttonTitle}
                />*/}
                {list
                  .filter((item) => item.eval === value)
                  .map((item, index) => {
                    return (
                      <li
                        className={styles.athlete}
                        key={`AthletesSummary__key__eval__${index}__${item.id}`}
                      >
                        <figure>
                          <img
                            className={styles.thumb}
                            src={item.picture.small}
                            title={item.name}
                            alt={item.name}
                          />
                          <figcaption className={styles.name}>
                            {item.name}
                          </figcaption>
                        </figure>
                      </li>
                    );
                  })}
              </ul>
            </li>
          );
        })}
      </ol>
    </section>
  );
}

AthletesSummary.propTypes = {
  athletes: PropTypes.arrayOf(
    PropTypes.shape({ ...athletePropTypes }).isRequired
  ),
  evaluation: PropTypes.objectOf(PropTypes.number),
  tab: PropTypes.number.isRequired,
  handleTabChange: PropTypes.func.isRequired,
};

export default AthletesSummary;
